import { IConsumptionGlobalSummaryDTO, IUnitValueDTO } from "@/interface"
import { ConsumptionSummaryUnitEnum, OverSpentTypeEnum } from "@/enums"
import { sortByValue } from "@/mega-ui/helpers/function"
import { convertResourceUnit } from "@/models/consumption/consumption-detail"
import { overSpentDataConstruction } from "@/helpers/function/overSpentDataConstructHelpers"

export enum OverSpentColorEnum {
    national = "#3EAADF",
    international = "#F1911F",
    premium = "#fdcb47",
    neutre = ""
}

export interface overSpentConstructDonuts {
    key: OverSpentTypeEnum;
    data: number[];
    backgroundColor: OverSpentColorEnum[];
    base: OverSpent;
}

export class OverSpent {
    credit: number;
    premium: number;
    national: number;
    international: number;

    constructor(base?: Partial<OverSpent>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    public static fromDto(dto: IConsumptionGlobalSummaryDTO) {
        if (!dto) {
            return null;
        }

        const overSpent = dto.cdrOverspent;
        function findElement(array: IUnitValueDTO[], key: string) {
            return array.find((element: IUnitValueDTO) => element.type === key)
        }

        const credit = findElement(overSpent, 'OSG_CREDIT')
        const premium = findElement(overSpent, 'DET_PREMIUM')
        const national = findElement(overSpent, 'DET_NATIONAL')
        const international = findElement(overSpent, 'DET_INTERNATIONAL')
        const roaming = findElement(overSpent, "DET_ROAMING")

        return new OverSpent({
            credit: convertResourceUnit(credit?.value, credit?.unit as ConsumptionSummaryUnitEnum),
            premium: convertResourceUnit(premium?.value, premium?.unit as ConsumptionSummaryUnitEnum),
            national: convertResourceUnit(national?.value, national?.unit as ConsumptionSummaryUnitEnum),
            international: +convertResourceUnit(international?.value, international?.unit as ConsumptionSummaryUnitEnum) 
                + +convertResourceUnit(roaming?.value, roaming?.unit as ConsumptionSummaryUnitEnum),
        });
    }

    public ItemsOverSpent(): OverSpentTypeEnum[] {
        const items:any = sortByValue<OverSpent>(this);
        delete items.credit;
        delete items.overSpentBalance;
        return Object.keys(items) as OverSpentTypeEnum[];
    }

    public consumptionDataChart(overSpentBalance: number): (overSpentConstructDonuts|null)[] {
        const itemsOverSpent = this.ItemsOverSpent().reverse();
        const arrayOverSpentData: overSpentConstructDonuts[] = [];
        return itemsOverSpent.map((item: OverSpentTypeEnum, index: number) => {
            const overSpentData = overSpentDataConstruction(item, this, overSpentBalance);
            if (!overSpentData) {
                return null;
            }
            
            arrayOverSpentData.push(overSpentData);
            if (index > 0) {
                arrayOverSpentData[(index - 1)].data[0]
                overSpentData.data[0] = overSpentData.data[0] + arrayOverSpentData[(index - 1)].data[0];
            }

            return overSpentData;
        }).reverse();
    }

    public consumptionDataChartNonNullValues(overSpentBalance: number): overSpentConstructDonuts[] {
        return this.consumptionDataChart(overSpentBalance).filter(e => e !== null) as overSpentConstructDonuts[]
    }
}
